import { render, staticRenderFns } from "./audit-entry.component.vue?vue&type=template&id=c2d06124&scoped=true"
import script from "./audit-entry.component.vue?vue&type=script&lang=ts"
export * from "./audit-entry.component.vue?vue&type=script&lang=ts"
import style0 from "./audit-entry.component.vue?vue&type=style&index=0&id=c2d06124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d06124",
  null
  
)

export default component.exports